export default function getTrails(state) {
  return state.trails.list;
}
